<div class="inventory-container py-4">
      <div class="d-flex justify-content-between align-items-center mb-4">
        <h2 class="fw-bold"><i class="bi bi-box-seam me-2 text-primary"></i>Inventario de Repuestos</h2>
        <span class="badge bg-primary px-3 py-2 rounded-pill shadow-sm" *ngIf="!isLoading">
          {{ (filteredProducts$ | async)?.length }} Items activos
        </span>
      </div>

      <!-- Filtros Superiores -->
      <div class="card border-0 shadow-sm mb-4 p-3 bg-white rounded-16">
        <div class="row g-3">
          <!-- Dropdown Categoría -->
          <div class="col-md-5">
            <label class="form-label small fw-bold text-muted text-uppercase">Categoría (Familia)</label>
            <select class="form-select border-0 bg-light rounded-12" [formControl]="categoryFilter">
              <option value="ALL">Todas las categorías</option>
              <option *ngFor="let cat of families" [value]="cat">{{ cat }}</option>
            </select>
          </div>
          
          <!-- Buscador Nombre -->
          <div class="col-md-7">
            <label class="form-label small fw-bold text-muted text-uppercase">Buscar por Nombre o Referencia</label>
            <div class="input-group">
              <span class="input-group-text border-0 bg-light rounded-start-12"><i class="bi bi-search text-muted"></i></span>
              <input type="text" 
                     class="form-control border-0 bg-light rounded-end-12" 
                     placeholder="Escriba el nombre del repuesto..." 
                     [formControl]="searchTerm">
            </div>
          </div>
        </div>
      </div>

      <!-- Pantalla de Carga -->
      <div *ngIf="isLoading" class="text-center py-5">
        <div class="spinner-grow text-primary" role="status"></div>
        <p class="mt-3 text-muted">Sincronizando inventario...</p>
      </div>

      <!-- Lista de Productos -->
      <div *ngIf="!isLoading" class="card border-0 shadow-sm overflow-hidden rounded-16">
        <div class="table-responsive">
          <table class="table table-hover align-middle mb-0">
            <thead class="bg-light">
              <tr class="small text-muted">
                <th class="ps-4 py-3">REF.</th>
                <th class="py-3">NOMBRE DEL PRODUCTO</th>
                <th class="py-3">CATEGORÍA</th>
                <th class="text-center py-3">STOCK ACTUAL</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let p of filteredProducts$ | async">
                <td class="ps-4 fw-mono small text-secondary">{{ p.id }}</td>
                <td>
                  <div class="fw-bold">{{ p.nombre }}</div>
                  <div class="small text-muted">{{ p.marca }} {{ p.modelo || '' }}</div>
                </td>
                <td>
                  <span class="badge bg-light text-dark border rounded-pill px-3">{{ p.Familia }}</span>
                </td>
                <td class="text-center">
                  <div [ngClass]="{
                    'text-danger fw-bold': (p.stock || 0) <= 2,
                    'text-warning fw-bold': (p.stock || 0) > 2 && (p.stock || 0) <= 5,
                    'text-dark': (p.stock || 0) > 5
                  }">
                    <i class="bi bi-layers me-1"></i> {{ p.stock || 0 }}
                  </div>
                </td>
                
              </tr>
              <tr *ngIf="(filteredProducts$ | async)?.length === 0">
                <td colspan="5" class="text-center py-5 text-muted">
                  <i class="bi bi-emoji-frown d-block fs-1 mb-2"></i>
                  No se encontraron productos con estos filtros.
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>